import type { ImgHTMLAttributes } from 'react';

/**
 * Meta/TikTok CDNs often block media when the document sends an external Referer (e.g. localhost / app origin).
 * Omitting the referrer fixes many 403s on <img> / <video>.
 */
export function inferMediaReferrerPolicy(
  src: string | undefined,
  explicit: ImgHTMLAttributes<HTMLImageElement>['referrerPolicy'] | undefined,
): ImgHTMLAttributes<HTMLImageElement>['referrerPolicy'] | undefined {
  if (explicit !== undefined && explicit !== '') return explicit;
  if (!src) return undefined;
  const s = src.toLowerCase();
  if (
    s.includes('cdninstagram.com') ||
    s.includes('instagram.com') ||
    s.includes('fbcdn.net') ||
    s.includes('tiktokcdn.com') ||
    s.includes('tiktokv.com') ||
    s.includes('ibyteimg.com') ||
    s.includes('twimg.com')
  ) {
    return 'no-referrer';
  }
  return undefined;
}
